module.exports = __webpack_public_path__ + "static/media/fin.90aae88c.jpg";